import { ICorporatePartner } from './corporate-partner.interface';

export class NuTravelSpidPartner implements ICorporatePartner {
  public name = 'nutravel-spid';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'fare';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}

export class NuTravelSmePartner implements ICorporatePartner {
  public name = 'nutravel-sme';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'rewards';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}

export class NuTravelSmeSkybPartner implements ICorporatePartner {
  public name = 'nutravel-skyb';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = false;
  public displayInlineText = 'rewards';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}

export class NuTravelNoProgramPartner implements ICorporatePartner {
  public name = 'nutravel-no-program';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'noprogram';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}
